// extracted by mini-css-extract-plugin
module.exports = {"module":"styles_module__1Wz6Q","rightBox":"styles_rightBox__3RRRi","logo":"styles_logo__32tk4","substrate":"styles_substrate__2C0s_"};